import { DocumentPage as DocumentPageContent } from './page'
import { DocumentPageDataProvider } from './queries'

export const DocumentPage = () => (
  <DocumentPageDataProvider>
    <DocumentPageContent />
  </DocumentPageDataProvider>
)
